import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';

const LogoutConfirmModal = ({isOpen, onClose, onConfirm}) => {
    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    return createPortal(
        <div className="rest-logout-modal" role="dialog" aria-modal="true" aria-labelledby="logout-modal-title">
            <button
                type="button"
                className="rest-logout-modal__backdrop"
                onClick={onClose}
                aria-label="بستن"
            />

            <div className="rest-logout-modal__card">
                <div className="rest-logout-modal__accent" aria-hidden="true"/>

                <div className="rest-logout-modal__icon" aria-hidden="true">
                    <svg className="h-7 w-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.75"
                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        />
                    </svg>
                </div>

                <h2 id="logout-modal-title" className="rest-logout-modal__title">
                    خروج از حساب
                </h2>

                <p className="rest-logout-modal__text">
                    اطلاعات ورود شما از این دستگاه پاک می‌شود.
                    برای استفاده دوباره باید وارد شوید.
                </p>

                <div className="rest-logout-modal__actions">
                    <button
                        type="button"
                        className="rest-logout-modal__btn rest-logout-modal__btn--ghost"
                        onClick={onClose}
                    >
                        انصراف
                    </button>
                    <button
                        type="button"
                        className="rest-logout-modal__btn rest-logout-modal__btn--danger"
                        onClick={onConfirm}
                    >
                        بله، خارج شوم
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default LogoutConfirmModal;
